import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

type DatePickerProps = Omit<DateTimePickerProps<Dayjs | null>, 'value' | 'onChange'> & {
  value: Date | null;
  onChange: (value: Date | null) => void;
};

const DatePicker = ({ value, onChange, disableFuture, ...props }: DatePickerProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        maxDateTime={disableFuture ? dayjs() : undefined}
        disableFuture={disableFuture}
        value={value ? dayjs(value) : null}
        onChange={(newValue) => onChange(newValue?.toDate() || null)}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
